var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFlag = function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3c0-.6-.4-1-1-1s-1 .4-1 1v14c0 .6.4 1 1 1s1-.4 1-1v-5c.6.5 1.6 1 2.7 1 .9 0 1.9-.5 2.8-1 .9-.5 1.9-1 2.8-1 2.3 0 3.7 2 3.7 2V5s-1.4-2-3.7-2c-.9 0-1.9.5-2.8 1-.9.5-1.9 1-2.8 1C6.6 5 5.6 4.5 5 4V3z"
  })));
};
export default SvgFlag;